var rex_php_tags = new RegExp("<\\?php(?:[\\n\\r]|.)+?\\?>(?!\"|'')", "gim");
var rex_script_tags = new RegExp("<script(?:[\\n\\r]|.)+?\\/script>", "gim");
var rex_comments_tags = new RegExp("<!--(?:[\\n\\r]|.)+?-->", "gim");

// Strips php contents /!\ THIS DELETES PHP TAGS AND EVERYTHING IN BETWEEN /!\
function stripPhpContents(str) {
    return str.replace(rex_php_tags, "");
}

// Strips js contents /!\ THIS DELETES SCRIPT TAGS AND EVERYTHING IN BETWEEN /!\
function stripJSContents(str) {
    return str.replace(rex_script_tags, "");
}

// Strips html comments /!\ THIS DELETES COMMENTS TAGS AND EVERYTHING IN BETWEEN /!\
function stripHTMLComments(str) {
    return str.replace(rex_comments_tags, "");
}

function stripCombo(str) {
    var output = stripHTMLComments(str);

    output = stripJSContents(output);
    output = stripPhpContents(output);

    return output;
}

var elmt;
var loader;
var prev_display;

// Shows button's underlying loader and triggers defined action
function waitingProcess(loader, action, id_form) {
    var elmt = $(this),
        loader = $(loader);

    prev_display = elmt.css("display");

    if (!loader.parent().hasClass("loading")) {
        loader.parent().addClass("loading");

        switch (action) {
            case 0:
                window.setTimeout(
                    ajax_checkAllForm,
                    1000,
                    tabAuthTop,
                    1,
                    path_relative_root
                );
                break;

            case 1:
                window.setTimeout(
                    ajax_checkAllForm,
                    1000,
                    tabLostPwdTop,
                    1,
                    path_relative_root
                );
                break;

            case 2:
                window.setTimeout(ajaxDeconnect, 1000, path_relative_root);
                break;

            case 3:
                window.setTimeout(function () {
                    checkAllForm(tabError, 0, path_relative_root, id_form);
                    loader.parent().removeClass("loading");
                }, 1000); // attention ne pas modifier le temps 1000 pour que le intelinput ai le temps de bien remplir les données
                break;

            case 4:
                window.setTimeout(
                    ajax_checkAllForm,
                    1000,
                    tabAuth,
                    1,
                    path_relative_root
                );
                break;

            case 5:
                window.setTimeout(
                    ajax_checkAllForm,
                    1000,
                    tabLostPwd,
                    1,
                    path_relative_root
                );
                break;

            case 6:
                window.setTimeout(checkFormParrainage, 1000);
                break;

            case 7:
                if (
                    checkAllForm(
                        tabErrorGrattez,
                        0,
                        path_relative_root,
                        id_form
                    )
                ) {
                    window.setTimeout(processGrattezGagnez(), 1000);
                }
                break;
        }
    }
}

function hideLoader() {
    if (loader) {
        loader.css("display", "none");
        loader
            .removeAttr("style")
            .parent()
            .removeClass("loading");
    }
    if (elmt) {
        elmt.css("display", prev_display);
    }
}

// Checks any form
function ajax_checkAllForm(
    tabError,
    blockMenuTopConnexionInfobulle,
    path_relative_root
) {
    if (checkAllForm(tabError, blockMenuTopConnexionInfobulle)) {
        if (tabError[0][1] && tabError[0][1] == "clientMailAuthTop") {
            $.ajax({
                url: path_relative_root + "ajax_login_allowed.php",
                type: "get",
                data: {
                    mail: document.getElementById(tabError[0][1]).value,
                    mdp: document.getElementById(tabError[1][1]).value,
                    is_top: true,
                },
                success: function (res) {
                    var url, index_deb, index_fin, provenance;

                    if (res[0] !== "0") {
                        url = window.location.pathname;
                        index_deb = url.lastIndexOf("/");
                        index_fin = url.lastIndexOf(".");
                        provenance = url.substring(index_deb + 1, index_fin);

                        if (provenance === "connexion") {
                            window.location.replace(
                                path_relative_root + create_link("client_index")
                            );
                        } else if (provenance === "identification") {
                            window.location.replace(
                                path_relative_root + "livraison-kiala.php"
                            );
                        } else {
                            window.location.reload();
                        }
                    } else {
                        document.getElementById("AuthTopErr").style.display =
                            "block";

                        $(".loader").css("display", "none");
                    }
                },
            });
        } else if (tabError[0][1] && tabError[0][1] == "mailLostTop") {
            var mail = document.getElementById(tabError[0][1]).value;

            $.ajax({
                url: path_relative_root + "ajax_email_exist.php",
                type: "get",
                data: {mail: mail},
                success: function (res) {
                    if (res == 1) {
                        $.ajax({
                            url:
                                path_relative_root +
                                "ajax_send_new_password_link.php",
                            type: "get",
                            data: {mail: mail},
                            succes: function () {
                                show_lightbox(
                                    "popup_confirm_reinitialisation_mdp"
                                );

                                document.getElementById(
                                    "lostpwdTopErr"
                                ).style.display =
                                    "none";
                                document.getElementById(
                                    "lostpwdTopSuccesTitle"
                                ).style.visibility =
                                    "hidden";

                                hideLoader();
                            },
                        });
                    } else {
                        document.getElementById("lostpwdTopErr").style.display =
                            "block";

                        hideLoader();
                    }
                },
            });
        } else if (tabError[0][1] && tabError[0][1] == "clientMailAuth") {
            $.ajax({
                url: path_relative_root + "ajax_login_allowed.php",
                type: "get",
                data: {
                    mail: document.getElementById(tabError[0][1]).value,
                    mdp: document.getElementById(tabError[1][1]).value,
                    is_top: false,
                },
                success: function (res) {
                    hideLoader();

                    if (res == 1) {
                        $("#auth").submit();

                        return true;
                    } else {
                        document.getElementById("AuthErrErr").style.display =
                            "block";

                        return false;
                    }
                },
            });
        } else if (tabError[0][1] && tabError[0][1] == "mailLost") {
            var mail = document.getElementById(tabError[0][1]).value;

            $.ajax({
                url: path_relative_root + "ajax_email_exist.php",
                type: "get",
                data: {mail: mail},
                success: function (res) {
                    if (res == 1) {
                        $.ajax({
                            url:
                                path_relative_root +
                                "ajax_send_new_password_link.php",
                            type: "get",
                            data: {mail: mail},
                            success: function (res) {
                                show_lightbox("popup_confirm_reinitialisation_mdp");
                                document.getElementById("lostpwdErr").style.display = "none";
                                document.getElementById("lostpwdSuccesTitle").style.visibility = "hidden";
                                hideLoader();
                                return false;
                            },
                        });
                    } else {
                        document.getElementById("lostpwdErr").style.display = "block";
                        hideLoader();
                        return false;
                    }
                },
            });
        }
    } else {
        $(".loader").css("display", "none");
    }
}

// Adds "display" rule to bond element's style with a value of "block"
function show() {
    this.show();
}

// Adds "display" rule to bond element's style with a value of "none"
function hide() {
    this.hide();
}

// Adds leading zeroes to a given value
function zeroPad(nbr, base) {
    var zpad;

    base = parseInt(base) > 1 ? base : 10;
    zpad = nbr < base ? "0" : "";

    return zpad + nbr.toString(base).toUpperCase();
}

// Alters item quantity in cart
function changeQte(type) {

    var types = ['plus', 'less'],
        item, loader, qtty, ajax_url;

    if (types.includes(type)) {

        item = this.getValue('item_id', parseFloat);
        loader = document.getElementById('qte_loader_' + item);
        qtty = this.getValue('selected_qte', parseFloat);

        this.qtty_select_wrap.style.display = 'none';
        loader.style.display = 'initial';

        switch (type) {
            case 'plus':
                qtty += 1;
                break;
            case 'less':
                qtty -= 1;
                break;
        }

        $.ajax({
            url: path_relative_root + create_link("order_basket"),
            type: 'post',
            data: {
                action: 'del',
                panierId: item,
                cad: 'non',
                pointcad: 0,
                qteProd: qtty,
                change_qte: true
            },
            cache: false,
            success: function (res) {

                try {
                    res = JSON.parse(res);
                } catch (e) {
                    console.error('JSON ERROR: could not parse data');
                    return false;
                }

                resHtml = $('<div />').html(res.datas);

                document.getElementById('main_cart_wrapper').innerHTML = $('#main_cart_wrapper', resHtml).html();
                if (wShop.$refs.wCouponForm) {
                    wShop.$refs.wCouponForm.reloadBloc += 1;
                }

                //update top cart

                var response = ajax_file("ajax_show_basket.php");
                document.getElementById('cart_top').innerHTML = response;

                cart = Translator.translate('mon_panier');
                var total = $('#cart_top .cart').attr('data-cart'),
                    text;

                if (total <= 1) {
                    text = Translator.translate('one_product');
                } else {
                    text = Translator.translate('2_product');
                }

                $('.cart_main_title.basket').html(cart + ' <span class="nb_products">(' + total + ' ' + text + ')</span>');
                $('#cart_total .nbProdCartTotal').html('<span class="nbProdCartTotal">' + total + ' ' + text + '</span>');

                /**
                 * Move out of stock products to the top of the cart
                 */
                updateCartElements();

                if (typeof initApplePayExpressCheckout === "function") {
                    initApplePayExpressCheckout();
                }

                if (res.error_message.length) {
                    $('#modboxpromo').find('.texte').html(res.error_message);
                    openMultiShad('modboxpromo');
                }
            },
            complete : function() {
                getWishlistProducts();
            }
        });
    }
}

// Reload product from ref
function loadProduct(new_id, type, page, itm_rr_id) {

    var form = this;
    var old_id = this.getValue('produit_id');
    var col_id = this.getValue(this.getValue('idCouleur'));
    var sze_id = this.getValue(this.getValue('idTaille'));
    var act = this.getValue('act');
    var qte_itm = 1;
    if (this.elements.namedItem('qteProd')) {
        var qte_itm = this.elements.namedItem('qteProd').value;
    }

    var is_model = this.getValue('hdn_is_model');
    var is_wishlist = $('#wishlist').length > 0;
    if ($('#tunnel_right_col').length > 0) {
        is_wishlist = false;
    }
    var is_achat_express = $('#is_achat_express_v2').val() == 1;
    itm_rr_id = itm_rr_id !== undefined ? itm_rr_id : '';
    var cpt_prod = itm_rr_id !== '' ? itm_rr_id.replace('_', '') : '';
    var data = {
        produit_id: old_id,
        produit_principal: old_id,
        couleurProd: col_id,
        tailleProd: sze_id,
        act: act,
        qteProd: qte_itm,
        hdn_product_id: old_id,
        hdn_is_model: is_model,
        produit_id_new: new_id,
        type: type,
        type_page: (page !== undefined && page !== '') ? page : 'product',
        is_achat_express: is_wishlist ? 1 : 0,
        is_achat_express_v2: is_achat_express && !is_wishlist ? 1 : 0,
        cpt_prod: cpt_prod - 1,
    };

    if (is_wishlist) {
        data.wishlist = true;
    }

    if (isGlobalEActive) {
        data.warehouse_only = 1;
    }

    $.ajax({
        type: 'post',
        url: path_relative_root + 'ajax_get_product_regroup_ref.php',
        data: data,
        success: function (res) {

            try {
                res = $.parseJSON(res);
            } catch (e) {
                console.error('parseJSON');
                return;
            }

            // Le cache ajax_regroupement (preprod) peut avoir mémorisé une réponse antérieure
            // à l'ajout du champ "success" : on se fie plutôt à la présence réelle du html_main.
            if (res.success == 'ok' || (res.datas && res.datas.html_main)) {
                if (window.dataLayer !== undefined) {
                    pushToWshopBus({
                        event: "view_item",
                    });
                }

                var datas = res.datas;
                if (data.type_page == 'product') {
                    var $html_main = $(stripCombo(datas.html_main));
                    var main_wrapper = $('.product_main_wrapper', $html_main);
                    var zoom_wrapper = $('.zoom_main_wrapper', $html_main);
                    var feats_wrapper = $('.product_feats_wrapper', $html_main);

                    if (data.is_achat_express_v2) {
                        // Photo et information
                        var itm_id = old_id + (itm_rr_id !== '' ? itm_rr_id.replace('_', '-') : '');

                        $('#itm-' + itm_id).replaceWith($html_main);

                        var new_itm_id = new_id + (itm_rr_id !== '' ? itm_rr_id.replace('_', '-') : '');
                        var margin_right = $('#itm-' + new_itm_id).next().css('margin-right');

                        if ($(".homepage").length > 0 || $(".satellite_store_details").length > 0) {
                            save_description = $('#itm-' + new_itm_id + ' .wrapper_description').html();
                            $('#itm-' + new_itm_id + ' .wrapper_description').html(save_description);
                            save_item_title = $('#itm-' + new_itm_id + ' .item_title').html();
                            $('#itm-' + new_itm_id + ' .item_title').html('<span>' + save_item_title + '</span>')
                            $('#itm-' + new_itm_id + ' .item_price').insertBefore('#itm-' + new_itm_id + '.wrap_rolloverproduit');

                            if ($(".satellite_store_details").length > 0) {
                                $('#itm-' + new_itm_id).addClass('swiper-slide');
                                $('#itm-' + new_itm_id).css('margin-right', margin_right);
                            }
                        } else if ($(".product_page").length > 0 || $(".rayon_lookbook").length > 0) {
                            if ($(".product_page").length > 0) {
                                $('#itm-' + new_itm_id + ' .imgWrapper').prepend($('#itm-' + new_itm_id + ' .item_price'));
                                $('#itm-' + new_itm_id).addClass('assoc');
                                $('#itm-' + new_itm_id).css('margin-right', margin_right);
                            } else if ($(".rayon_lookbook").length > 0) {
                                $('#itm-' + new_itm_id + ' .imgWrapper').addClass('imgWrapperinlook');
                            }
                        }

                        $('input.color_' + new_id + itm_rr_id).prop('checked', false);
                        $('input#color_' + new_id + '_' + data.couleurProd + itm_rr_id).prop('checked', true);
                    } else if (is_wishlist) {
                        // Photo et information
                        $('.product_main_wrapper', '#lightbox_achat_express').html(main_wrapper.html());
                        // Description compo, livraison, guide tailles
                        $('.product_feats_wrapper', '#lightbox_achat_express').html(feats_wrapper.html());
                    } else {
                        var color = $("#ligne_couleur").html();
                        var cms_page_wrapper = $('.product_cms_bloc', $html_main);
                        var assoc_rayon_wrapper = $('.assoc_rayon', $html_main);

                        // Photo et information
                        $('.product_main_wrapper', '#site_global_wrap').html(main_wrapper.html());

                        // Zoombox
                        $('.zoom_main_wrapper', '#site_global_wrap').html(zoom_wrapper.html());

                        // Description compo, livraison, guide tailles
                        $('.product_feats_wrapper', '#site_global_wrap').html(feats_wrapper.html());

                        // Cms page module
                        $('.product_cms_bloc', '#site_global_wrap').html(cms_page_wrapper.html());

                        // Association rayon
                        $('.assoc_rayon', '#site_global_wrap').html(assoc_rayon_wrapper.html());

                        $("#ligne_couleur").html(color);
                        $('input.color').prop('checked', false);
                        $('input#color_' + data.couleurProd).prop('checked', true);

                        $("#ctaAvailabilityInStoreTitle").html(Translator.translate('availabilityInStore'));

                        if (document.getElementById("alma-widget") !== null) {
                            initAlmaWidget();
                        }

                        // On scroll en haut de la page dans le cas d'un regroupement
                        $('html, body').animate({
                            scrollTop: 0
                        }, 500);

                        // Reload Join Stories widget for the newly selected colour (SW-21340)
                        var joinWidget = $('.product_main_wrapper .join-widget-target-component', '#site_global_wrap')[0];
                        if (joinWidget && typeof window.loadJoinStoriesWidget === 'function') {
                            window.loadJoinStoriesWidget(joinWidget);
                        }
                    }

                    if ($("#buyNowSwiper").length > 0) {
                        var buyNowSwiper = document.getElementById("buyNowSwiper");

                        if (buyNowSwiper.getElementsByClassName("swiper-slide").length) {
                            buyNowSwiper = new Swiper("#buyNowSwiper", {
                                slidesPerView: 1,
                                spaceBetween: 50,
                                navigation: {
                                    nextEl: ".swiper-button-next",
                                    prevEl: ".swiper-button-prev",
                                }
                            });
                        }
                    }

                    rayon_sticky_block();
                    swiperAssociation();
                    swiperArticlesVue();
                    initAssocProductCarousel();
                    initProductSizeFieldset('.product_main_wrapper');

                    $('.sizesList label').on("click", function () {
                        $('.choices_list').removeClass('opened');
                    });

                } else if (type_page == 'look') {
                    var $html_main = $(stripCombo(datas.html_main));
                    var $html_middle = $(stripCombo(datas.html_middle));
                    var color = $("#ligne_couleur").html();
                    var main_wrapper = $('.product_main_wrapper', $html_main);
                    var feats_wrapper = $('.product_feats_wrapper', $html_main);
                    var contents = $('<div />').html($html_main);

                    // Photo et information
                    $('.product_main_wrapper', '#lightbox_achat_express').html(main_wrapper.html());

                    // Description compo, livraison, guide tailles
                    $('.product_feats_wrapper', '#lightbox_achat_express').html(feats_wrapper.html());
                    $('#ref_look_' + produit_principal).html($('#ref_look_' + produit_principal, $html_main).html());
                    $('#look_add_lightbox_' + produit_principal).html($('#look_add_lightbox_' + produit_principal, $html_main).html());

                    calculTotal('slide_look_detail');
                    $('#itm_thumb_list').empty();

                    var thumbnails = loadPrevisu();
                    parseThumbList(thumbnails);
                    var $id_current = id_prod.substring(id_prod.lastIndexOf("_") + 1);
                    var i = array_look.indexOf(parseInt($id_current));

                    if (i != -1) {
                        array_look.splice(i, 1);
                    }

                    // Une fois les informations chargés on vas mettre à jour le select des quantités avec le nouveau produit choisie
                    showQteListeGamme('liste_qte_' + datas.product.id, datas.product.id, path_relative_root);
                }

                json_colisages = res.stock;
                // On definie les tailles qui ont encore du stock
                setAvailableSizes.call($('[name="itm_color"]:checked', $(form)));

                initializeItemSliders();

                // L'item ravon rendu par le serveur reprend les sizes du preset 'grid' par défaut :
                // si la liste est actuellement en vue par 3, il faut rebasculer sur 'grid_three'.
                if (data.is_achat_express_v2 && typeof switchVisu === 'function') {
                    switchVisu();
                }

                if (wShop.$refs.wAlertestockForm) {
                    wShop.$refs.wAlertestockForm.reloadBloc += 1;
                }

                //Simulates scroll (2px) to load images
                setTimeout(function () {
                    window.scrollTo(0, $(window).scrollTop() + 3);

                }, 100);

                lazyImageLoader(); // custom image lazyloading function

            } else {
                $('#btn_error').fadeIn();
            }
        },
        complete: function () {

            var heads = $("[data-tab-head]");
            var containers = $("[data-tab-container]");

            if (window.YT_Player !== undefined) {
                window.YT_Player.destroy();
                window.YT_Player = undefined;
                window.YT_vid_id = undefined;
            }

            initTaille();

            var activateTab = function (event) {
                event.preventDefault();

                var element = $(this);
                var tab_number = element.attr("data-tab");
                var head_container = element.parent();
                var container_name, container, scrollpane;

                head_container.addClass("current").siblings().removeClass("current");
                container_name = head_container.parent().attr("data-tab-head");
                container = containers.filter("[data-tab-container='" + container_name + "']");
                scrollpane = container.find("[data-tab]").hide().filter("[data-tab='" + tab_number + "']").show().find('.scroll-pane');

                if (scrollpane.length > 0) {
                    scrollpane.jScrollPane();
                }
            };

            setTimeout(function () {
                initFpMainSlider();

                var productImgsWrapper = $(".productImgsWrapper");
                var productDescrWrapper = $(".productDescrWrapper");

                $(document).on("scroll", function () {
                    var scrollTop = $(document).scrollTop();
                    var newTop = (scrollTop - (productImgsWrapper.innerHeight() - productDescrWrapper.innerHeight()));

                    if (scrollTop >= productImgsWrapper.innerHeight() - productDescrWrapper.innerHeight()) {
                        productDescrWrapper.css("top", "-" + newTop + "px");
                    } else {
                        productDescrWrapper.css("top", "auto");
                    }
                });

                setTimeout(function () {
                    checkSubmitState();
                    eventButton();
                }, 300);
            }, 250);

            heads.each(function () {
                var head = $(this);
                var children = head.children();

                children.removeClass("current").filter(":first").addClass("current");
                children.find('[data-tab]').click(activateTab);
            });

            $("[data-tab-container]").children('div').eq(Math.abs(1 - $('.current', "[data-tab-head]").index())).css('display', 'none');

            var assocs_elm = $('#assocs_slider', '#site_global_wrap').get(0);
            var ranges_elm = $('#ranges_slider', '#site_global_wrap').get(0);

            if ((data.type_page == 'product' && !data.is_achat_express_v2)) {
                getAvailableQuantity.call($('form.product_info', '#site_global_wrap').get(0), data.produit_id_new, data.qteProd, '', data.couleurProd, itm_rr_id, is_wishlist);
            }
            $('#addToWishlistButton', '#site_global_wrap').on('click', addToWishlist);

            if (!data.is_achat_express_v2) {
                checkProductInWishlist();
            }

            if (is_wishlist) {
                // event sur le bouton d'ajout à la wishlist
                $("#addToWishlistButton").on("click", addToWishlist);
            }

            // After swiper load, reload dailymotions videos
            try {
                initDailymotionVideos();
            } catch (e) {
                console.error(e);
            }

            //Simulates scroll (2px) to load images
            setTimeout(function () {
                window.scrollTo(0, $(window).scrollTop() + 3);
            }, 100);
        }
    });
}

// Called upon color change in product page
function onItemColorChange(form, is_regroup, itm_rr_id) {
    var control, prod_id;
    itm_rr_id = itm_rr_id !== undefined ? itm_rr_id : '';
    var is_wishlist = $('#wishlist').length > 0;

    if ($('#tunnel_right_col').length > 0) {
        is_wishlist = false;
    }

    var is_achat_express_v2 = ($('#is_achat_express_v2').val() == 1 && !is_wishlist);

    if (this.checked) {
        control = form.elements.namedItem(form.getValue('idCouleur'));
        control.value = this.value.trim();
        prod_id = form.getValue('itm_id_' + control.value + itm_rr_id).trim();
        itm_rr_id = itm_rr_id !== '' ? '_' + itm_rr_id.split('_')[1] : '';
        if (is_regroup) {
            loadProduct.call(form, prod_id, 'couleur', '', itm_rr_id);
        } else {
            // On regarde si le produit est dejà dans la wishlist
            if (!is_achat_express_v2) {
                checkProductInWishlist();
            }

            var img = $(this).data('pic');

            changeVisu('img_large', img);

            // On definie les tailles qui ont encore du stock
            setAvailableSizes.call(this);
        }

        initProductSizeFieldset(".product_main_wrapper");
    }
}

// Called upon size change in product page
function onItemSizeChange(form, event, itm_rr_id) {
    if ($(form).hasClass('product_info')) {
        $("#bloc_add_basket #btn_add_cart").addClass("unlock");
    }
    else {
        $("#bloc_add_basket #btn_add_cart").removeClass("unlock");
    }
    var control;
    var is_wishlist = $('#wishlist').length > 0;

    if ($('#tunnel_right_col').length > 0) {
        is_wishlist = false;
    }

    var is_achat_express_v2 = ($('#is_achat_express_v2').val() == 1 && !is_wishlist);
    itm_rr_id = itm_rr_id !== undefined ? itm_rr_id : '';

    if (this.checked) {

        if (window.dataLayer !== undefined) {
            if (window.dataLayer[0].product) {
                window.dataLayer[0].product.size = ($(this).attr('data-nom'));
            }
        }

        if ($('#sizeerror').is(':visible')) {
            $('#sizeerror').slideUp();
        }

        var id = form.getValue('produit_id');
        var elem = is_achat_express_v2 ? '_' + id + itm_rr_id : '';

        control = form.elements.namedItem('tailleProd');
        control.value = this.value.trim();

        // En fonction de la couleur on regarde si le produit est disponible
        getAvailableQuantity($('#produit_principal' + elem).val(), $('#qteProd' + elem).val(), 'product', event, itm_rr_id, is_wishlist, this);
        // On regarde si le produti est dejà dans la wishlist
        if (!is_achat_express_v2) {
            checkProductInWishlist();
        }

        // When TG module has a background color that can be set in BO, stock alert is transparent, so we need to hide product description
        if ($('.tg-module').length) {

            $('.item').each( function () {
                var tgAchatExpress = $(this).find('.rollover_left.achat_express');
                var productDescription = $(this).find('.wrapper_description');
                var confirmationMsg = $(this).find('.bloc_add_alert_confirmation');
                var errorMsg = $(this).find('.bloc_add_alert_erreur');

                if (tgAchatExpress.css('display') === 'none') {
                    productDescription.addClass('alert_stock_open');
                } else if (!confirmationMsg.css('display') === 'none') {
                    productDescription.addClass('alert_stock_open');
                } else if (!errorMsg.css('display') === 'none') {
                    productDescription.addClass('alert_stock_open');
                }
            });
        }

        // bottom achat express need scroll to display price, so we simulate it
        if ($('.product_info').hasClass('scrolling-active')) {
            setTimeout(function(){
                window.scrollTo(window.scrollX, window.scrollY + 1);
                window.scrollTo(window.scrollX, window.scrollY - 1);
            },);

            $(form).find('.input_check.size').removeClass('selected');
            $(this).addClass('selected');
        }
    }
}

/**
 * Fetches and updates the available quantity of a product based on selected attributes.
 *
 * @param {number} id - The product ID.
 * @param {number} qty - The quantity to check.
 * @param {string} from - The source of the request (e.g., 'basket').
 * @param {Event} event - The event that triggered the function.
 * @param {string} [itm_rr_id] - The item RR ID, if applicable.
 * @param {boolean} [is_wishlist] - Indicates if the request is from a wishlist.
 * @param {HTMLElement} [currentElem] - The current element.
 *
 * @returns {void}
 */
function getAvailableQuantity(id, qty, from, event, itm_rr_id, is_wishlist, currentElem) {

    let visitedArticles = (currentElem && currentElem.classList && currentElem.classList.contains("visited_articles_size")) ? "#gondole_derniers_articles_vus " : "";
    itm_rr_id = (itm_rr_id !== undefined) ? itm_rr_id : '';
    var is_achat_express = $('#is_achat_express_v2').val() == 1 && !is_wishlist;
    var elem = is_achat_express ? '_' + id + itm_rr_id : '';
    var form = (this instanceof HTMLFormElement) ? this : document.querySelector(visitedArticles + '#prod_info_' + id + itm_rr_id);
    var color_id = $(visitedArticles + '#couleurProd' + elem).val();
    var size_id = $(visitedArticles + '#tailleProd' + elem).val();
    // If no size or color is already selected, then we do not perform any verification
    if (color_id == '' || size_id == '') {
        return;
    }


    // Add loading class to the loader if not in "achat express" mode
    if (!(is_achat_express)) {
        $('#btn_add_cart + .loader').addClass('loading');
    }

    var data = {
        idprod: $(visitedArticles + '#produit_id' + elem).val(),
        idcouleur: color_id,
        idtaille: size_id,
        json: '1',
        isGlobalEActive: isGlobalEActive,
    };

    if (from == 'basket') {
        data.suff = $(visitedArticles + '#produit_id' + elem).val();
    }

    $.ajax({
        url: path_relative_root + 'ajax_liste_qte.php',
        type: 'get',
        async: true, // Should be async but would then need a loader so...
        dataType: 'json',
        data: data,
        success: function (res) {

            let inventoryData = res.inventory;
            let productIsSfs = res.is_sfs !== "undefined" ? res.is_sfs : false;
            var datalayerProduct = res.dataLayer_object
                && res.dataLayer_object.ecommerce
                && res.dataLayer_object.ecommerce.detail
                && res.dataLayer_object.ecommerce.detail.products
                && res.dataLayer_object.ecommerce.detail.products[0];

            var change_color_even_id = res.dataLayer_object
                    && res.dataLayer_object.ecommerce
                    && res.dataLayer_object.ecommerce.event_id
                    ? res.dataLayer_object.ecommerce.event_id : '';

            if (window.dataLayer !== undefined && datalayerProduct && datalayerProduct.refSizeColor) {
                pushToWshopBus({
                    'event': 'changeSize',
                    'produit': {
                        'size_value': datalayerProduct.size,
                        'refSizeColor': datalayerProduct.refSizeColor,
                        'change_color_even_id': change_color_even_id,
                    }
                });
            }

            $("#btn_resa_shop").toggle(res.has_stock_store === true);

            if (!inventoryData.enableAddToCart) {
                if (!$('.size_title_content').hasClass('noStock')) {
                    $('.size_title_content').addClass('noStock');
                }

                /**
                 * Flag alert stock
                 * If enable, bloc_add_alert exist in DOM, hide add basket and display alert stock
                 * If disabled, bloc_add_alert don't exist in DOM, display disabled add basket
                 */
                if ($(visitedArticles + ".bloc_add_alert" + elem).length > 0) {
                    $(visitedArticles + ".bloc_add_alert" + elem).show();
                    $(visitedArticles + ".product_main_wrapper #size_is_not_available").show();
                    if (!is_achat_express) {
                        $(visitedArticles + "#bloc_add_basket").hide();
                    }
                } else {
                    if (is_achat_express) {
                        $(visitedArticles + "#bloc_size_not_available" + elem).show();
                    } else {
                        $(visitedArticles + ".product_main_wrapper #size_is_not_available").show();
                        disableAddCart();
                    }
                }

                $(".eclat_product_nouveaute_fiche_produit").show();
                if (document.querySelector(visitedArticles + "#prod_info" + elem + " .rollover_left")) {
                    document.querySelector(visitedArticles + "#prod_info" + elem + " .rollover_left").style.display = "none";
                }
                $("#qteProd").val(0);

                $('#ligne_qte').append($('.restock_date'));
                $('.taunt_text').css('display', 'none');
            } else {
                $('.size_title_content').removeClass('noStock');
                // If product have stock
                if (!is_achat_express) {
                    $(visitedArticles + ".product_main_wrapper #size_is_not_available").hide();
                }

                if (inventoryData.stockQuantity > 0 && inventoryData.stockQuantity <= 3) {
                    $('.taunt_text').css('display', 'block');
                } else {
                    $('.taunt_text').css('display', 'none');
                }

                if (is_achat_express) {
                    var from = '';

                    if ($('#in_basket').val() == 1) {
                        from = 'basket';
                    }

                    waitingAddToBasket(event, form, from, itm_rr_id);
                } else {
                    $(".eclat_product_nouveaute_fiche_produit").hide();
                    $(".bloc_add_alert").hide();
                    $("#bloc_add_basket").show();
                    $("#qteProd").val(1);
                }
            }

            // Check if globale delivery country
            if (!inventoryData.enableAddToCart) {
                if (isGlobalEActive && productIsSfs == false) {
                    $("#bloc_add_basket").hide();
                    $("#bloc_add_alert").show();
                    $(".product_main_wrapper #size_" + size_id).addClass('disabled');
                }
            }

            $('#btn_add_cart + .loader').removeClass('loading');
        }
    });

    // Only if customer connected or has favorite store
    if ($('.button_ask').length == 0) {
        var data = {
            produitId: $(visitedArticles + '#produit_id' + elem).val(),
            colorId: color_id,
            sizeId: size_id,
            json: '1'
        };

        updateAvailabilityByStore(data);
    }
}

function closeSizeNotAvailable(elem) {
    let visitedArticles = (this && this.classList && this.classList.contains("visited_articles_alert_return")) ? "#content_obj " : "";
    // Hide bloc bloc_size_not_available_
    $("#bloc_size_not_available_" + elem).hide();

    // Show bloc colors and size
    $("#prod_info_" + elem + " .rollover_left").show();
    $("#ligne_pointure_" + elem).show();
    $("#ligne_couleur_" + elem).show();

    if ($('body').hasClass('product_page') && $('form#prod_info_' + elem).hasClass('lightbox')) {
        var elementToMove = $('form#prod_info_' + elem);
        var elementDestination = $('#asso_product_carousel').find('.swiper-slide[data-produit-id="'+ elem.split('_')[0] +'"]');

        elementToMove.removeClass('lightbox actif');
        elementToMove.appendTo(elementDestination.find('.wrap_rolloverproduit'));
        $('form#prod_info_' + elem + ' .form_submit.bloc_add_color.loading').show();
        $('#shad').removeClass('actif');
    }
}

function newUpdatePanier_legacy(
    idProduit,
    i,
    paniervirtuelId,
    prixU,
    path_web,
    titreObjet,
    idElTaille,
    lastTaille,
    idElCouleur,
    lastCouleur
) {
    if (i != "") {
        i = "_" + i;

        prixU = $("#prixU" + i).val();
    }

    var couleurs = document.getElementById("couleurProd" + i);
    var tailles = document.getElementById("tailleProd" + i);
    var $alertbox = $("#alertbox1");
    var res = "";
    var html_err = "";
    var flagError = false;

    html_err = '<div class="txt_alert"></div><div class="rosette"></div>';
    html_err +=
        '<div class="wrapper_btn"><a onclick="closeMultiShad();" href="#" class="btn_alert">OK</a></div>';
    if ($alertbox.length == 0) {
        $alertbox = $('<div id="alertbox1">' + html_err + "</div>");
        $("body").append($alertbox.hide());
    }

    if (tailles && tailles.value == "") {
        res = ajax_file(path_web + "ajax_sprintf.php?arg1=js_error_size");
        flagError = true;
    } else if (couleurs && couleurs.value == "") {
        res = ajax_file(path_web + "ajax_sprintf.php?arg1=js_error_couleur");
        flagError = true;
    } else if (
        document.getElementById("qteProd" + i) &&
        document.getElementById("qteProd" + i).value == ""
    ) {
        res = ajax_file(path_web + "ajax_sprintf.php?arg1=js_error_quantity");
        flagError = true;
    }

    if (flagError) {
        $alertbox.find(".txt_alert").html(res);
        openMultiShad("alertbox1");
        return false;

    } else {
        var qte = 0;

        if ($("#qteProd" + i)) {
            qte = $("#qteProd" + i).val();
        }

        var idCouleur = 0;
        var idTaille = 0;

        if (couleurs && couleurs.value != "none") idCouleur = couleurs.value;
        if (tailles && tailles.value != "none") idTaille = tailles.value;

        var array_response = new Array();
        var response = ajax_file(
            path_web +
            "ajax_upd_panier.php?prixu=" +
            prixU +
            "&idprod=" +
            idProduit +
            "&idcouleur=" +
            idCouleur +
            "&idtaille=" +
            idTaille +
            "&qte=" +
            qte +
            "&panierId=" +
            paniervirtuelId
        );

        if (response) {
            array_response = response.split("//");

            var designation = array_response[0];

            if (titreObjet.match("^[0-9]")) {
                if (designation == 1) {
                    designation += " lot de";
                } else {
                    designation += " lots de";
                }
            }

            designation += " " + titreObjet;

            if (document.getElementById(idElTaille)) {
                if (document.getElementById(idElTaille).selectedIndex) {
                    designation +=
                        " - Taille " +
                        document.getElementById(idElTaille).options[
                            document.getElementById(idElTaille).selectedIndex
                            ].text;
                } else if (lastTaille != "") {
                    designation += " - Taille " + lastTaille;
                }
            }

            if (document.getElementById(idElCouleur)) {
                if (document.getElementById(idElCouleur).selectedIndex) {
                    designation +=
                        " - " +
                        document.getElementById(idElCouleur).options[
                            document.getElementById(idElCouleur).selectedIndex
                            ].text;
                } else if (lastCouleur != "") {
                    designation += " - " + lastCouleur;
                }
            }

            array_response[0] = designation;
        }

        return array_response;
    }
}

// Pretty straightforward: this formats a price
var formatPrice = (function () {
    var THREEDIGITS = new RegExp("\\d{3}", "g");

    // Splits a number into chunks of 3 digits
    function splitThousands(nmbr) {
        var f_chunk = "",
            chunk_length;

        nmbr = String(nmbr);
        chunk_length = nmbr.length % 3;

        if (chunk_length) {
            f_chunk = nmbr.slice(0, chunk_length);
            nmbr = nmbr.substr(chunk_length);
        }

        return (
            f_chunk +
            nmbr.replace(THREEDIGITS, function (match) {
                return " " + match;
            })
        );
    }

    return function (price) {
        var FORMAT = window.price_format_plain;
        var CURRENCY = window.siteCurrency;
        var output;

        if (price.constructor !== String) {
            price = price.toString(10);
        }

        price = price.replace(".", ",");
        price = price.split(",");
        var decimal = (typeof price[1] !== "undefined" ? price[1] : '');
        var no_cents = (decimal === '00' || decimal === '');

        if (no_cents && typeof window.PRICE_FORMAT_PLAIN_JS_NO_CENTS != 'undefined' && window.PRICE_FORMAT_PLAIN_JS_NO_CENTS !== 'PRICE_FORMAT_PLAIN_JS_NO_CENTS') {
            FORMAT = window.PRICE_FORMAT_PLAIN_JS_NO_CENTS;
        }

        output = FORMAT.replace("[<unit>]", splitThousands(price[0]));
        output = output.replace("[<symbol_right>]", CURRENCY.symbol_right);
        output = output.replace("[<symbol_left>]", CURRENCY.symbol_left);
        output = output.replace("[<decimal>]", decimal);
        output = output.replace("[<code>]", CURRENCY.code);

        return output;
    };
})();

function filterAutoAdjust() {
    // By default
    const headerHeight = $('#site_head_wrap').innerHeight();
    $('.bloc_sub_categ').css('top', headerHeight + 'px');

    // Select the target node to observe
    const targetNode = document.getElementById('GlobaleFreeShippingBannerContainer');

    // Configuration for the MutationObserver
    const config = {
        attributes: true,                // Observe attribute changes
        attributeFilter: ['class']       // Observe only changes to the 'class' attribute
    };

    // Callback function to execute when mutations are observed
    const callback = function(mutationsList) {
        // Iterate over each observed mutation
        for (const mutation of mutationsList) {
            // Check if the observed mutation is a change in the 'class' attribute to 'none'
            if (mutation.type === 'attributes' && mutation.attributeName === 'class' && targetNode.classList.contains('none')) {
                // Call your function to handle the attribute change
                const headerHeight = $('#site_head_wrap').innerHeight();
                $('.bloc_sub_categ').css('top', headerHeight + 'px');
            }
        }
    };

    // Create a new MutationObserver with the specified callback and configuration
    const observer = new MutationObserver(callback);

    // Start observing the target node with the specified configuration
    if (targetNode) {
        observer.observe(targetNode, config);
    }
}

$(function () {
    $(document).on("click", ".productFeatTitle", function () {
        var productFeatTitle = $('.productFeatTitle');
        var productFeatDescription = $('.productFeatDescription');
        var that = $(this);
        if (that.hasClass('current')) {
            that.next(productFeatDescription).slideUp("fast", function () {
                that.removeClass('current');
            });
        } else {
            that.next(productFeatDescription).slideDown("fast", function () {
                that.addClass('current');
            });
        }
    });

    if ( $( ".contact_faq #form_contact1" ).length ) {
        $(".contact_faq .contactForm_content_right .contact").css("display", "block");
    }

    filterAutoAdjust();

    // FIX: Hide mbway submit button when mbwayWaiting is not in cache
    const mbwayWaiting = document.getElementById('mbwayWaiting');
    const mbwaySubmit = document.querySelector('.mbway_submit');
    const mbwayInputNum = document.querySelector('.mbway_hipay .w-input-container');

    if (mbwayWaiting && mbwaySubmit && mbwayInputNum) {
        const observer = new MutationObserver(() => {
            if (!mbwayWaiting.classList.contains('cache')) {
                mbwaySubmit.style.display = 'none';
                mbwayInputNum.style.display = 'none';
            } else {
                mbwaySubmit.style.display = '';
                mbwayInputNum.style.display = '';
            }
        });

        observer.observe(mbwayWaiting, { attributes: true, attributeFilter: ['class'] });
    }

    // FIX: Hide bizum submit button when bizumWaiting is not in cache
    const bizumWaiting = document.getElementById('bizumWaiting');
    const bizumSubmit = document.querySelector('.bizum_submit');
    const bizumInputNum = document.querySelector('.bizum_hipay .w-input-container');

    if (bizumWaiting && bizumSubmit && bizumInputNum) {
        const bizumObserver = new MutationObserver(() => {
            if (!bizumWaiting.classList.contains('cache')) {
                bizumSubmit.style.display = 'none';
                bizumInputNum.style.display = 'none';
            } else {
                bizumSubmit.style.display = '';
                bizumInputNum.style.display = '';
            }
        });

        bizumObserver.observe(bizumWaiting, { attributes: true, attributeFilter: ['class'] });
    }

    // Hide Bancomat Pay submit button when bancomatpayWaiting is not in cache
    const bancomatpayWaiting = document.getElementById('bancomatpayWaiting');
    const bancomatpaySubmit = document.querySelector('.bancomatpay_submit');
    const bancomatpayInputNum = document.querySelector('.bancomatpay_hipay .w-input-container');

    if (bancomatpayWaiting && bancomatpaySubmit && bancomatpayInputNum) {
        const bancomatpayObserver = new MutationObserver(() => {
            if (!bancomatpayWaiting.classList.contains('cache')) {
                bancomatpaySubmit.style.display = 'none';
                bancomatpayInputNum.style.display = 'none';
            } else {
                bancomatpaySubmit.style.display = '';
                bancomatpayInputNum.style.display = '';
            }
        });

        bancomatpayObserver.observe(bancomatpayWaiting, { attributes: true, attributeFilter: ['class'] });
    }

    ['newBlocGenerated', 'filterSelected'].forEach(eventName => {
        window.addEventListener(eventName, function() {
            initializeItemSliders();
        });
    });

    // newBlocSearchGenerated fires before Vue increments pageSize (setTimeout 0 vs 500),
    // so new galleries are not yet in the DOM — delay past the 500 ms render window.
    window.addEventListener('newBlocSearchGenerated', function() {
        setTimeout(initializeItemSliders, 550);
    });

    window.addEventListener('newFilterSearchGenerated', function() {
        document.querySelectorAll('.productSwiper').forEach((slider) => {
            if (slider.swiper) {
                slider.swiper.destroy();
            }
            //slide.classList.remove('swiper-initialized');
        });
        setTimeout(() => {
            initializeItemSliders();
        }, 250);
    });

    document.addEventListener("search_onSearchEnd_end", function(event) {
        initializeItemSliders();
    });
});

// INSCRIPTION NEWSLETTER
// La gestion de l'inscription à la newsletter
$("input#newsletter_home").click(function () {
    $.ajax({
        url: path_relative_root + "ajax_newsletter_email.php",
        type: "post",
        data: {
            email: $("#newsletter_email").val(),
            provenance: "footer",
            sous_provenance: $("#newsletter_email").attr("data-lang"),
        },
        cache: false,
        success: function (res) {
            var resultat = JSON.parse(res);

            if (resultat.valid == false) {
                $("#newsletter_email").addClass("inputErr");
            } else {
                $("#error_newsletter").removeClass("error");
                $("#error_newsletter").addClass("valid");
                $("#newsletter_email").removeClass("inputErr");
            }

            $("#error_newsletter").html(Translator.translate(resultat.message));
        },
    });
});

function closeAlerteStock(elem) {
    // Hide bloc alert stock
    $('.bloc_add_alert_' + elem).hide();
    $("#prod_info_" + elem + " .rollover_left").show();

    // Show bloc colors and size
    $('#ligne_pointure_' + elem).show();
    $('#ligne_couleur_' + elem).show();

    // Reset mail input
    $('.bloc_add_alert_' + elem + ' .alert_stock').show();
    $('.bloc_add_alert_' + elem + ' .bloc_add_alert_form').show();
    $('.bloc_add_alert_' + elem + ' .bloc_add_alert_confirmation').hide();

    //Show/hide alerte stock in maintenance section on Product Page
    if ($('body').hasClass('product_page') && $('form#prod_info_' + elem).hasClass('lightbox')) {
        var elementToMove = $('form#prod_info_' + elem);
        var elementDestination = $('#asso_product_carousel').find('.swiper-slide[data-produit-id="'+ elem.split('_')[0] +'"]');

        elementToMove.removeClass('lightbox actif');
        elementToMove.appendTo(elementDestination.find('.wrap_rolloverproduit'));
        $('form#prod_info_' + elem + ' .form_submit.bloc_add_color.loading').show();
        $('#shad').removeClass('actif');
    }

    // When TG module has a background color that can be set in BO, stock alert is transparent, so we need to show product description
    if ($('.tg-module').length) {

        $('.item').each( function () {
            var tgAchatExpress = $(this).find('.rollover_left.achat_express');
            var productDescription = $(this).find('.wrapper_description');
            var confirmationMsg = $(this).find('.bloc_add_alert_confirmation');
            var errorMsg = $(this).find('.bloc_add_alert_erreur');

            if (!tgAchatExpress.css('display') === 'none') {
                productDescription.removeClass('alert_stock_open');
            } else if (confirmationMsg.css('display') === 'none') {
                productDescription.removeClass('alert_stock_open');
            } else if (errorMsg.css('display') === 'none') {
                productDescription.removeClass('alert_stock_open');
            }
        });
    }
}

function closeAlerteStockWishlist(elem) {
    $('.bloc_add_alert_' + elem + ' .alert_stock').removeClass('show');
    $('.bloc_add_alert_' + elem + ' .bloc_add_alert_form').hide();
    $('.bloc_add_alert_' + elem + ' .alert_return').hide();

    if ($('.bloc_add_alert_' + elem + ' .bloc_add_alert_confirmation').css('display') !== 'none') {
        var alertStockElement = $('.bloc_add_alert_' + elem + ' .alert_stock');
        alertStockElement.removeClass('show');
        alertStockElement.css('display', 'flex');
        $('.bloc_add_alert_' + elem + ' .bloc_add_alert_confirmation').hide();
    }
}

// YOUTUBE LOGIC
var YT_Player, YT_vid_id;

function onYouTubeIframeAPIReady() {
    YT_Player = new YT.Player('popup_video', {
        videoId: YT_vid_id,
        playerVars: {
            rel: 0
        }
    });

    if ($('#videoBox').is(':visible')) {
        YT_Player.playVideo();
    }
}

function initYTPlayer() {
    var tag = document.createElement('script');

    tag.id = 'YT_player_script';
    tag.src = "https://www.youtube.com/iframe_api";

    document.body.appendChild(tag);
}

/**
 * La video dans la fiche produit
 * (champs produit_video) Charge une video à partir de Youtube
 */
function show_video(vid) {
    var video = $('#videoBox');

    $(window).scrollTop(0);

    if (!YT_Player) {
        YT_vid_id = vid;

        if (!document.getElementById('YT_player_script')) {
            initYTPlayer();
        } else {
            onYouTubeIframeAPIReady();
        }
    }

    $('#shad').off('click', stop_video).after(video);
    $('#shad').stop(true, true).fadeIn('slow', function () {
        video.css({display: 'block', opacity: 0}).animate({opacity: 1}, function () {
        });

        $('#shad').one('click', stop_video);
    });
}

function stop_video() {
    var video = $('#videoBox');

    if (video.css('display') != 'none') {
        video.css({display: 'block', opacity: 1}).animate({opacity: 0}, function () {

            $('#shad').stop(true, true).fadeOut('slow', function () {
                if (YT_Player !== undefined) {
                    YT_Player.seekTo(0).stopVideo();
                }

                video.css({display: 'none'});
            });
        });
    }
}

// Function push into DataLayer
function pushIntoDatalayer(data) {
    if (typeof (data) == 'object') {
        pushToWshopBus(data);
    } else if (typeof (data) == 'string') {
        pushToWshopBus(JSON.parse(data));
    }
}

function dataLayer_associated_product() {
    if (window.$('#gondole_aimerez')) {
        var product_id = this.getAttribute('data-prod') ? event.currentTarget.getAttribute('data-prod') : '';
        var productObj = null;

        if (product_id !== '') {
            if (typeof data_layer_products != 'undefined' && data_layer_products.length > 0) {
                data_layer_products.forEach(function (item) {
                    if (item.id == product_id) {
                        productObj = item;
                    }
                })
            } else if (typeof data_layer_products_aimerez != 'undefined') {
                var objs = Object.keys(data_layer_products_aimerez);
                var values = Object.values(data_layer_products_aimerez);

                for (var i = 0; i < objs.length; i++) {
                    if (values[i].id == product_id) {
                        productObj = values[i];
                    }
                }
            }

            var prod = productObj;

            if (productObj !== null && productObj !== undefined) {
                pushToWshopBus({
                    'event': 'productClick',
                    'ecommerce': {
                        'click': {
                            'actionField': {'list': productObj['category']}, // Optional list property.
                            'products': [prod]
                        }
                    },
                    'eventCallback': "function () {document.location = productObj.url}"
                });
            }
        }
    }
}

function triggerProductDatalayerPush(prod_id, url) {
    if (typeof productlist_gondole !== 'undefined') {
        for (var i = 0; i < productlist_gondole.length; i++) {
            prod = productlist_gondole[i];
            if (prod.id == prod_id) {
                window.list = prod['list'];
                delete prod['list'];
                pushToWshopBus({
                    'event': 'productClick',
                    'ecommerce': {
                        'click': {
                            'actionField': {'list': list},      // Optional list property.
                            'products': [prod]
                        }
                    },
                    'eventCallback': 'function() { document.location = url}',
                });
            }

        }
    }
}

/**
 *
 * @param product_id
 * @param regroup_ref_id
 * use in : app/views/_components/product/achat_express.php
 */
function achatExpressV2(product_id, regroup_ref_id) {
    var btn = $(this);

    // Loader
    btn.parent('.form_submit').addClass('loading');

    var elem = regroup_ref_id ? '_' + product_id + regroup_ref_id: '_' + product_id;
    var form = document.getElementById('prod_info' + elem);
    var color_id = form.elements['couleurProd'].value;
    var size_id = form.elements['itm_size'].value;
    var tailleProdCrossSell = $('#qteProd_' + product_id + regroup_ref_id );

    if (($('#size_'+product_id+"_"+size_id + regroup_ref_id, $('#prod_info' + elem)) != undefined && $('#size_'+product_id+"_"+size_id + regroup_ref_id, $('#prod_info' + elem)).length == 1 && $('#size_'+product_id+"_"+size_id + regroup_ref_id, $('#prod_info' + elem)).hasClass('disabled')) || ($('#tailleProd_' + product_id + '_' + regroup_ref_id).value == '0') || (typeof tailleProdCrossSell[0] != "undefined" && tailleProdCrossSell[0].value == "0")) {
        var parent = $(this).parent();

        $(this).parent().hide();

        if ($('body').hasClass('product_page') && $('.blocEntretien').length) {
            var elementToMove = $('form#prod_info' + elem);
            var sizen_a = $('#bloc_size_not_available' + elem);
            var productId = elementToMove.attr('id').split("_")[2];

            if (elementToMove.length) {
                $('#site_global_wrap > div:first').append(elementToMove);
                elementToMove.find('.rollover_left.achat_express #ligne_couleur' + elem).hide();
                elementToMove.find('.rollover_left.achat_express #ligne_pointure' + elem).css('display', 'flex');
                elementToMove.addClass('lightbox actif');

                if (sizen_a.length) {
                    sizen_a.css('display', 'flex');
                }
            }

            $('#shad').addClass('actif').on('click', function() {
                $(this).removeClass('actif');

                elementToMove.removeClass('lightbox actif');

                // Move form back to its initial position
                $('.blocEntretien .swiper-slide[data-produit-id*="' + productId + '"] .wrap_rolloverproduit').append(elementToMove);

                parent.show();
            });
        }

        $('#bloc_add_alert' + elem).show();
    } else {
        if (color_id !== '' && size_id !== '') {
            waitingAddToBasket(event, form, '', regroup_ref_id);
            setTimeout(function() {
                btn.parent('.form_submit').removeClass('loading');
            }, 2000);
        } else if (color_id === '' && size_id === '') {
            alert(translate('choose_a_size_and_a_color'));
            // Loader
            btn.parent('.form_submit').removeClass('loading');
        } else if (color_id === '') {
            alert(translate('choose_a_color'));
            // Loader
            btn.parent('.form_submit').removeClass('loading');
        } else if (size_id === '') {
            alert(translate('choose_a_size'));
            // Loader
            btn.parent('.form_submit').removeClass('loading');
        }
    }
}

function initAssocProductCarousel() {
    if ($(".asso_product_carousel").length) {
        instaSwiper = new Swiper(".asso_product_carousel", {
            slidesPerView: 4.216,
            spaceBetween: 10,
            freeMode: true,
        });
    }
}

if ($("body.product_page").length) {
    initAssocProductCarousel();
}

// ADV categories
function selectAllMonths(obj, year) {
    if ($(obj).is(':checked')) {
        $('#date_filter_wrapper input[year=' + year + ']:not(":checked")').trigger('click');
    } else {
        $('#date_filter_wrapper input[year=' + year + ']:checked').trigger('click');
    }
}

// Filter articles
function filterArticles(element) {
    let checkedFilters = $('#date_filter_wrapper input[type=checkbox][name="dates[]"]:checked');

    if (checkedFilters.length) {
        checkedFilters.each(function () {
            let value = $(this).val();

            if (value.length == 7) {
                if ($('#date_filter_wrapper input[type=checkbox]').click(function () {
                    let checked = $(this).is(':checked');
                    if (checked) {
                        $(this).addClass('selected-item');
                    } else {
                        $(this).removeClass('selected-item');
                    }
                })) ;
            }
        });
    }
    let page = element.dataset.page;
    if (typeof page === "undefined") {
        page = 1;
    }
    getArticles(page);
}
var articles_xhr;
function getArticles(page)
{
    let form = $("#filterByDates");
    $("#page").val(page);
    let formData = form.serializeArray();

    if (articles_xhr) {
        articles_xhr.abort();
    }
    articles_xhr  = $.ajax({
        method: 'POST',
        data: formData,
        url: path_relative_root + 'ajax_get_cms_pages.html',
        success: function (res) {
            let translatedTextArticle = (res.nb_articles > 1) ? 'articles' : 'article';
            $('#nb_article').html(res.nb_articles + ' ' + Translator.translate(translatedTextArticle));

            $("#content_previsu_cms_page").html(res.content.articles);
            $("#cms_pagination").html(res.content.pagination);
            $("#cms_subcategory_menu .cms_menu_item.filter").removeClass("open");
        }
    });
}
$(function() {
    if ($("#cms").length) {
        $("#cms").addClass("visible");
    }
})
